var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m14 4.667-8 8L2.333 9l.94-.94L6 10.78l7.06-7.053.94.94Z"}));
}

Check.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = Check;

Check.default = Check;
